import { useTranslation } from "react-i18next";
import './componentStyle.css'

const LeftSideComponent=()=>{
  const { t } = useTranslation();

  return (
    <div className="left-side-container">
      <a href="https://www.insee.fr" className="insee-button" target="_blank" rel="noreferrer noopener">
        <img src='https://www.insee.fr/en/outil-interactif/5543645/images/logo-insee.svg' alt="logo_insee"></img>
      </a>
      <h1 className="title">{t("app_title")}</h1>
    </div>
  );
}

export default LeftSideComponent